import api from '../api.service';

const settingsRepository = {
  // Get all settings
  getAll: async () => {
    const response = await api.get('/settings');
    return response; // Return full response
  },

  // Update settings
  update: async (data) => {
    const response = await api.put('/settings', data);
    return response; // Return full response, not response.data
  },

  // Upload logo
  uploadLogo: async (file, type) => {
    const formData = new FormData();
    formData.append('logo', file);
    formData.append('type', type);
    
    // Don't set Content-Type header - browser will set it automatically with boundary
    const response = await api.post('/settings/upload-logo', formData);
    return response; // Return full response, not response.data
  },
};

export default settingsRepository;
